import { useEffect, useState } from 'react';
import classNames from 'classnames';

// Hooks
import { useAppDispatch, useAppSelector } from '../../store';

// Actions
import { resetNotification } from '../../store/slices/mainSlice';

// Styles
import styles from './Notification.module.scss';

const Notification = () => {
  const dispatch = useAppDispatch();
  const { message, isError } = useAppSelector(s => s.main.notification);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const animationTimer = setTimeout(() => {
      setVisible(false);
    }, 2500);
    const timer = setTimeout(() => {
      dispatch(resetNotification());
    }, 3000);

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(timer);
    };
  }, [dispatch]);

  return (
    <div
      className={classNames(styles.errorNotification, {
        [styles.show]: visible,
        [styles.hide]: !visible,
        [styles.isError]: isError,
      })}
    >
      {message}
    </div>
  );
};

export default Notification;
